import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface AlcadaModal {
  errors: any;
}

@Component({
  selector: 'app-alcada-alert',
  templateUrl: './alcada-alert.component.html',
  styleUrls: ['./alcada-alert.component.scss']
})

export class AlcadaAlertComponent extends DialogComponent<AlcadaModal, boolean> implements AlcadaModal {

  errors: any;
  
  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  confirm() {
    this.close();
  }
}


// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/alcada-alert/alcada-alert.component.ts